<div
  class="switch"
  (click)="toggleSwitch()"
  (keydown.enter)="toggleSwitch()"
  [class.on]="isOn"
  tabindex="0"
>
  <div class="toggle"></div>
</div>
